import { ArrowTrendingUpIcon, ChevronRightIcon } from '@heroicons/react/24/outline'

import ContentFrame from 'components/Frame/ContentFrame'

export default function BasicStatCard({
    title = 'Title',
    icon = null,
    value = 0,
    // trendValue = 0,
    // trendSubText = 'recently added',
    onClick = () => { console.log('Add a card action') }
}) {
    return (
        <ContentFrame>
            <div 
                className="w-full flex items-center p-6 gap-x-4 cursor-pointer hover:bg-gray-50 transition-all"
                onClick={onClick}
            >
                <div className="h-12 w-12 rounded-lg bg-orange-400 flex items-center justify-center">
                    {icon}
                </div>

                <div className='flex-1'>
                    <div className="text-sm tracking-wide">{title}</div>

                    <div className='flex items-end gap-x-4'>
                        <div className="text-xl font-semibold text-gray-900 tabular-nums">{value}</div>
                    </div>
                </div>

                {/* 
                {trendValue > 0 &&
                    <div className='bg-gray-100 pl-3 pr-4 py-1 rounded-full flex items-center gap-x-1'>
                        <ArrowTrendingUpIcon className='h-4 w-4' />
                        <div className='text-xs'>{trendValue} {trendSubText}</div>
                    </div>
                } 
                */}

                <ChevronRightIcon className="h-6 w-6 text-gray-400 group-hover:text-orange-500 transition-colors" />
            </div>
        </ContentFrame>
    )
}